import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/api`;

export default function HousingDetail() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [housing, setHousing] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${API_BASE_URL}/housings/qr/${uuid}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) throw new Error('Housing not found');
        return res.json();
      })
      .then(setHousing)
      .catch(err => setError(err.message));
  }, [uuid]);

  if (error) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0f172a', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'sans-serif' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
      <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>Housing Not Found</div>
      <div style={{ color: '#94a3b8', fontSize: 14, marginBottom: 24 }}>{error}</div>
      <button onClick={() => navigate('/')} style={{ padding: '10px 24px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: 8, fontSize: 15, cursor: 'pointer' }}>← Back to Map</button>
    </div>
  );

  if (!housing) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
      <div style={{ color: '#94a3b8', fontSize: 14 }}>Loading...</div>
    </div>
  );

  const chassisLabel = housing.chassis_type === '12-slot' ? '4U · 12-Slot' : '2U · 4-Slot';

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0f172a', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column' }}>

      {/* Header */}
      <div style={{ backgroundColor: '#1e293b', borderBottom: '1px solid #334155', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => navigate('/')} style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid #334155', color: 'white', padding: '8px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}>← Map</button>
        <div style={{ flex: 1 }}>
          <div style={{ color: 'white', fontWeight: 'bold', fontSize: 18 }}>{housing.label || 'Fiber Housing'}</div>
          <div style={{ color: '#64748b', fontSize: 13, marginTop: 2 }}>{housing.location_name}</div>
        </div>
      </div>

      {/* Body */}
      <div style={{ flex: 1, padding: 20, maxWidth: 520, width: '100%', margin: '0 auto', boxSizing: 'border-box' }}>

        {/* Location breadcrumb */}
        <div style={{ backgroundColor: '#1e293b', borderRadius: 10, padding: '14px 16px', marginBottom: 16, border: '1px solid #334155' }}>
          <div style={{ color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>Location</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ color: '#e2e8f0', fontSize: 15, fontWeight: 'bold' }}>{housing.location_name}</span>
            <span style={{ color: '#475569' }}>›</span>
            <span style={{ color: '#94a3b8', fontSize: 14 }}>{housing.rack_name}</span>
            <span style={{ color: '#475569' }}>›</span>
            <span style={{ color: '#94a3b8', fontSize: 14 }}>U{housing.rack_unit_start}</span>
          </div>
        </div>

        {/* Housing details card */}
        <div style={{ backgroundColor: '#1e293b', borderRadius: 10, padding: '14px 16px', marginBottom: 16, border: '1px solid #334155' }}>
          <div style={{ color: '#94a3b8', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>Housing Details</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            {[
              { label: 'Chassis', value: chassisLabel },
              { label: 'Rack Position', value: `U${housing.rack_unit_start}` },
              { label: 'Manufacturer', value: housing.manufacturer || '—' },
              { label: 'Model', value: housing.model || '—' },
            ].map(({ label, value }) => (
              <div key={label}>
                <div style={{ color: '#475569', fontSize: 11, marginBottom: 3 }}>{label}</div>
                <div style={{ color: '#e2e8f0', fontSize: 14, fontWeight: '500' }}>{value}</div>
              </div>
            ))}
          </div>
        </div>

        {/* UUID */}
        <div style={{ backgroundColor: '#1e293b', borderRadius: 10, padding: '12px 16px', marginBottom: 24, border: '1px solid #334155' }}>
          <div style={{ color: '#475569', fontSize: 11, marginBottom: 4 }}>QR UUID</div>
          <div style={{ color: '#475569', fontFamily: 'monospace', fontSize: 11, wordBreak: 'break-all' }}>{housing.qr_uuid}</div>
        </div>

        {/* Primary CTA — View Cassettes */}
        <button
          onClick={() => navigate(`/housing/${housing.id}`)}
          style={{
            width: '100%', padding: '16px', backgroundColor: '#2563eb',
            color: 'white', border: 'none', borderRadius: 12,
            fontSize: 17, fontWeight: 'bold', cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(37,99,235,0.4)',
            marginBottom: 12,
          }}
        >
          View Cassettes →
        </button>

        {/* Secondary — back to rack */}
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%', padding: '13px', backgroundColor: 'transparent',
            color: '#94a3b8', border: '1px solid #334155', borderRadius: 12,
            fontSize: 15, cursor: 'pointer',
          }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
}
